import { Modal } from 'antd';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import media from 'utils/mediaStyle';
import utilsMessages from 'utils/messages';
import Button from '../Button/Button';
import SVGIcon from '../SVGIcon/SVGIcon';
import Heart from './Heart.svg';
import HeartFull from './HeartFull.svg';

export const FavoriteIcon = styled(SVGIcon)`
  width: 20px;
  svg {
    width: 100%;
  }
`;
export const Favorite = styled(Button)<any>`
  position: ${({ position }) => position || 'absolute'};
  z-index: 100;
  box-shadow: none;
  border: ${({ isShowBorder }) => (isShowBorder ? '1px solid #d5d7d5' : 'none')};
  background: #ffffff;
  :active,
  :focus,
  :hover {
    background: #ffffff;
  }
  top: ${({ alignto }) => (alignto === 'bottom' ? 'auto' : '4px')};
  bottom: ${({ alignto }) => (alignto === 'bottom' ? '4px' : 'auto')};
  right: 8px;
  width: ${({ isProductDetail }) => (isProductDetail ? '40px' : '26px')} !important;
  height: ${({ isProductDetail }) => (isProductDetail ? '40px' : '26px')} !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${media.md`
    top: ${({ alignto, isProductDetail }) => (alignto === 'auto' ? 'auto' : isProductDetail ? '16px' : '8px')};
    right: ${({ alignto, isProductDetail }) => (alignto === 'auto' ? 'auto' : isProductDetail ? '16px' : '8px')};
  `};
`;

const FavoriteContainer = ({ onClick, intl, favorite, ...rest }: any) => {
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!Boolean(favorite)) {
      return onClick(event);
    }
    const removeFavoriteMessage = intl.formatMessage(utilsMessages.removeFavoriteMessage);
    const yes = intl.formatMessage(utilsMessages.yes);
    const no = intl.formatMessage(utilsMessages.no);
    Modal.confirm({
      autoFocusButton: null,
      title: removeFavoriteMessage,
      okText: yes,
      cancelText: no,
      onOk: () => {
        onClick(event);
      },
      okButtonProps: {
        danger: true,
      },
    });
  };

  const icon = Boolean(favorite) ? HeartFull : Heart;

  return (
    <Favorite type="secondary" shape="circle" {...rest} onClick={handleClick}>
      <FavoriteIcon renderAsImg={false} src={icon} aria-label="Add to favorite" />
    </Favorite>
  );
};

export default injectIntl(FavoriteContainer);
